import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONFLICT_ERROR_PARAMS, MessageType } from 'app/shared/constants';
import { Message, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService, private translate: TranslateService) {}

  showErrorToast(error: any) {
    const errorCode: string | undefined = error.error?.errorCode;
    const statusCode: number | undefined = error.error?.statusCode;
    const params: string[] | string | undefined = error.error?.params;

    if (!errorCode) {
      this.showToast(MessageType.ERROR, this.translate.instant('TOAST.GENERAL_ERROR'));
      return;
    }

    if (statusCode == 409 && Array.isArray(params)) {
      const enumValues: string[] = Object.values(CONFLICT_ERROR_PARAMS);
      const existingParams: string[] = params?.filter((param) => enumValues.includes(param?.toUpperCase())) ?? [];
      if (existingParams.length > 0) {
        for (const param of existingParams) {
          this.showToast(MessageType.ERROR, this.translate.instant(`SERV_ERR.${param?.toUpperCase()}`));
        }

        return;
      }
    }

    this.showToast(MessageType.ERROR, this.translate.instant(`SERV_ERR.${errorCode}`));
  }

  showToast(severity: MessageType, detail?: string) {
    this.messageService.add({
      severity,
      summary: this.getTitle(severity),
      detail,
    });
  }

  showMultipleToast(severities: MessageType[], details?: string[]) {
    this.messageService.addAll(
      severities.map((x, index): Message => {
        return {
          severity: x,
          summary: this.getTitle(x),
          detail: details?.[index],
        };
      })
    );
  }

  private getTitle(type: MessageType): string {
    switch (type) {
      case MessageType.SUCCESS:
        return this.translate.instant('TOAST.SUCCESS');
      case MessageType.ERROR:
        return this.translate.instant('TOAST.ERROR');
      case MessageType.WARNING:
        return this.translate.instant('TOAST.WARNING');
      case MessageType.INFO:
        return this.translate.instant('TOAST.INFO');
      case MessageType.DISCONNECT:
        return this.translate.instant('TOAST.DISCONNECTED');
    }
  }
}
